import Modal from "../../../../molecules/Modal"
import WarningIcon from "../../../../../assets/icons/Warning"
import Button from "../../../../atoms/Button"
import styles from "./index.module.scss"

export const ModalGo = ({
  title,
  description,
  onFirstBtn,
  bgBtn,
  isLoad,
  onSecondBtn,
  titleBtnOne,
  titleBtnTwo,
  isTwoBtns = false,
}) => {
  return (
    <Modal isOpen={true}>
      <Modal.Header
        style={{
          justifyContent: "center",
          padding: "0.5rem",
        }}
        onClose={() => {}}
        bIconClose={false}
      >
        <h1 className={styles.titleModal}>{title}</h1>
      </Modal.Header>

      <div className={styles.flexCenter}>
        <WarningIcon />
        <p>{description}</p>
      </div>
      <div className={styles.containerButton}>
        <Button type="button" variant="outline" onClick={onFirstBtn}>
          {titleBtnOne}
        </Button>
        {isTwoBtns && (
          <Button
            style={{ background: bgBtn && bgBtn }}
            isLoading={isLoad}
            onClick={() => {
              onSecondBtn()
            }}
          >
            {titleBtnTwo}
          </Button>
        )}
      </div>
    </Modal>
  )
}
